import React from 'react'
import { Redirect } from 'react-router-dom'
import { hasModule } from '../auth'

/** Permission gate for a manage page. */
function RequireModule({ moduleKey, children }) {
  if (!hasModule(moduleKey)) {
    return <Redirect to="/manage" />
  }
  return children
}

function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="d-flex flex-wrap justify-content-between align-items-start mb-3">
      <div>
        <h1 className="manage-page-title">{title}</h1>
        {subtitle ? <p className="manage-page-sub mb-0">{subtitle}</p> : null}
      </div>
      <div className="d-flex flex-wrap align-items-center">{actions}</div>
    </div>
  )
}

function formatInr(value) {
  if (value == null || value === '') return '₹ 0'
  const n = Number(value)
  if (Number.isNaN(n)) return String(value)
  return '₹ ' + n.toLocaleString('en-IN')
}

function downloadCsv(filename, columns, rows) {
  const escape = (v) => {
    const s = v == null ? '' : String(v)
    if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`
    return s
  }
  const header = columns.map((c) => escape(c.label)).join(',')
  const body = (rows || [])
    .map((row) =>
      columns
        .map((c) => escape(c.get ? c.get(row) : row[c.key]))
        .join(',')
    )
    .join('\n')
  const blob = new Blob([header + '\n' + body], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

const BTN_PRIMARY = { backgroundColor: '#fd7e14', borderColor: '#fd7e14' }

export { RequireModule, PageHeader, formatInr, downloadCsv, BTN_PRIMARY }
